export default "__VITE_ASSET__CHxWIXjP__"